import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-detail.css.lit';

/**
 * Detail component
 * @element pc-detail
 * @slot - This element has a default slot
 */
@customElement('pc-detail')
export class PCDetail extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-detail': PCDetail;
  }
}
